module.exports = __webpack_public_path__ + "static/media/ash-canvas.fb05a50e.jpg";